import React from "react";
import ComingSoon from "../../../components/ComingSoon";

export default function DigitalMarketing() {
  return <ComingSoon title="Digital Marketing" />;
}
